module.exports = __webpack_public_path__ + "img/info.24c96189.svg";